import { Lupamaarays } from "@/Lupa.ts";
import { getLocalizedProperty } from "@/services/lomakkeet/utils";

export const getKuntamaaraysvalue = (
  maarays: Lupamaarays,
  localeUpper: string
): string => {
  if (maarays.koodiarvo === "200") {
    // Ulkomaat
    return maarays.meta.arvo as string;
  } else {
    // Opetus Suomessa
    return getLocalizedProperty(maarays.koodi.metadata, localeUpper, "nimi");
  }
};
